import styled from "styled-components";
import { ReactComponent as ArrowDown } from "../../../assets/icons/ArrowDown.svg";
import { theme } from "../../../theme";

interface Props {
  title?: string;
  isOpen?: boolean;
  hasButton?: boolean;
  onClickTitle?: () => void;
}
const PageLayout: React.FC<Props> = (props) => {
  const { title, children, isOpen, hasButton, onClickTitle } = props;

  return (
    <StyledContainer>
      <PageTitle hasButton={hasButton} onClick={onClickTitle}>
        {title}
        {!hasButton ? null : <StyledArrow isHidden={!isOpen} />}
      </PageTitle>
      {isOpen === undefined ? (
        <StyledChildWrapper>{children}</StyledChildWrapper>
      ) : (
        <StyledChildWrapper isOpen={isOpen}>{children}</StyledChildWrapper>
      )}
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  background-color: white;
  padding-bottom: 40px;
  border-radius: 8px;
`;
const PageTitle = styled.div<{ hasButton?: boolean }>`
  cursor: ${({ hasButton }) => (hasButton ? "pointer" : "default")};
  padding: 16px;
  ${theme.typo.heading.b18};
  width: 100%;
  display: flex;
  justify-content: space-between;
  box-shadow: inset 0px -1px 0px #e2e2e2;
`;
const StyledArrow = styled(ArrowDown)<{ isHidden?: boolean }>`
  transform: scaleY(${({ isHidden }) => (isHidden ? -1 : 1)});
  transition: 0.3s;
`;
const StyledChildWrapper = styled.div<{ isOpen?: boolean }>`
  display: ${({ isOpen }) => {
    return isOpen === undefined ? "default" : !isOpen ? "none" : "default";
  }};
  padding: 24px;
  width: 100%;
`;
export default PageLayout;
